module.exports = __webpack_public_path__ + "static/media/LoaderComponentsScreen.37ad99a7.png";